export const numberInRange = (num, min, max) => {
	return num >= min && num <= max
}
